<template>
  <div v-if="loading" class="text-center py-4">
    <b-spinner variant="primary" />
  </div>
  <div v-else class="text-center py-2 text-muted">
    {{ $t('No data for table') }}
  </div>
</template>

<script>
import { BSpinner } from 'bootstrap-vue';

export default {
  name: 'TableNoResultFound',
  components: {
    BSpinner
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  }
};
</script>
